import React, { useState } from 'react';

import './hover-state.css';
import { useTranslations } from 'next-intl';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import { useGetCurrentUser } from '@wwe-portal/web/providers/queries/user-info';
import { useGetCurrencies } from '@wwe-portal/web/providers/queries/offer';
import { Button } from '@wwe-portal/ui/components/button/button';
import { ClickableDiv } from '@wwe-portal/ui/components/button/clickable-div';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';

import { formatThousands } from '@wwe-portal/utils/format';
import { cn } from '@wwe-portal/ui/lib/lib';
import LoadAnimateButton from '../../load-animate-button';

//
type Props = {
  price: any;
  initialPrice: any;
  onHandlePurchase: any;
  transactionStarted: any;
  offerContent?: (string | null | undefined)[] | undefined;
  offerDescription?: string | undefined;
  currency: any;
  offerId: any;
  stockQuantity: any;
  show: any;
  setShow: any;
  offerType: any;
  isActiveDay: any;
  isInFuture: any;
  isHomeWidget?: boolean | undefined;
  hasWebCoinPrice?: boolean | undefined;
  webCoinPrice?: number | undefined;
  isWebCoinCard?: boolean | undefined;
  ruby?: boolean | undefined;
  index: any;
};

export function OfferCardHoverState({
  price,
  initialPrice,
  onHandlePurchase,
  transactionStarted,
  offerContent = [],
  offerDescription = '',
  currency,
  offerId,
  stockQuantity,
  show,
  setShow,
  offerType,
  isActiveDay,
  isInFuture,
  isHomeWidget = false,
  hasWebCoinPrice = false,
  webCoinPrice = 0,
  isWebCoinCard = false,
  ruby = false,
  index,
}: Props) {
  const [selected, setSelected] = useState(false); // false - "Contents" --- true - "Description"

  const t = useTranslations();

  const isAuthenticated = useIsAuthenticated();
  const currentUser = useGetCurrentUser();
  const { data: activeCurrenciesData } = useGetCurrencies();
  const activeCurrencies = activeCurrenciesData?.data?.data;

  const isFreeTournamentOffer = offerType === 'tournament' && !price;

  const offerContentFiltered = offerContent.map((content) => content || '');
  const rubiesExistInOfferContent =
    offerContentFiltered.filter(
      (content) =>
        content.includes('rubies') ||
        content.includes('Rubies') ||
        content.includes('ruby') ||
        content.includes('Ruby')
    ).length > 0;

  const renderButton = () => {
    return (
      <Button
        disabled={
          (!stockQuantity ||
            (!isActiveDay && offerType === 'daily') ||
            isInFuture) &&
          isAuthenticated &&
          currentUser
        }
        onClick={transactionStarted === offerId ? null : onHandlePurchase}
        data-id={`hover_state_${offerId}_button`}
        variant="orange"
        className="hover-state__button px-15 m-auto flex items-center justify-center py-0"
        style={{
          width: isHomeWidget ? '90%' : 140,
          height: isHomeWidget ? 46 : 30,
        }}
      >
        {transactionStarted === offerId ? (
          <div style={{ padding: 3 }}>
            <LoadAnimateButton />
          </div>
        ) : (!stockQuantity ||
            isInFuture ||
            (!isActiveDay && offerType === 'daily')) &&
          isAuthenticated &&
          currentUser ? (
          <p className={`m-0 p-[5px] text-xs`}>
            {isInFuture || (!isActiveDay && offerType === 'daily')
              ? t('not_ready')
              : offerType === 'rewards' || isFreeTournamentOffer
                ? t('claimed')
                : t('purchased')}
          </p>
        ) : (
          <>
            {offerType === 'rewards' ||
            (offerType === 'tournament' && !price) ? (
              <p className="mb-0 ml-[1px] p-[5px] text-xs font-semibold">
                {t('claim')}
              </p>
            ) : (
              <div className="flex items-center">
                {hasWebCoinPrice ? (
                  <IcoMoonIcon iconName="web-coin-circle" className="size-4" />
                ) : (
                  <div
                    style={{
                      minWidth: '18px',
                      minHeight: '18px',
                      lineHeight: 0,
                    }}
                  >
                    <img src="/assets/icons/money-dollar.svg" />
                  </div>
                )}
                <p
                  className={cn(`mb-0 ml-[1px] p-[5px] text-xs font-semibold`, {
                    'text-4': isHomeWidget,
                  })}
                >
                  {hasWebCoinPrice ? formatThousands(webCoinPrice) : price}{' '}
                  {hasWebCoinPrice ? '' : currency}
                </p>
              </div>
            )}
          </>
        )}
      </Button>
    );
  };

  const handleCloseIcon = () => {
    // if (Titan) {
    //   setEventCounter('web_store_telemetric');
    //   Titan.SendEvent({
    //     name: 'sys.ui',
    //     parameters: {
    //       screen_id: previousPageNameIdRenderer(pathname).id || null,
    //       screen_name: previousPageNameIdRenderer(pathname).pageName || null,
    //       screen_type: 'screen',
    //       screen_category: getCurrencyFromStorage(offerType)?.replace(
    //         /-/g,
    //         '_'
    //       ),
    //       screen_subcategory: 'offer',
    //       screen_content: offerId,
    //       previous_screen_id: null,
    //       previous_screen_name: null,
    //       previous_screen_category:
    //         previousPageNameIdRenderer(getStorageItem('previousPath'))
    //           .pageName || null,
    //       index: getEventCounter('web_store_telemetric'),
    //       interaction_type: 'tap',
    //       interaction_object: 'close_button',
    //       interaction_object_category: null,
    //       flow_name: 'web_store_telemetric',
    //       flow_order: null,
    //       session: sessionStorage.getItem('session') || null,
    //       sys_user_id: currentUser?.userId || null,
    //       sys_platform: 'web',
    //       sys_os_s: getOS(),
    //     },
    //   });
    // }
    setShow(false);
  };

  const renderSelectedContent = () => {
    if (selected) {
      return (
        <div className="hover-state__blur__list scrollbar-moz text-text400 px-0 text-xs">
          <p className="description">{offerDescription}</p>
        </div>
      );
    }

    return (
      <ul className="hover-state__blur__list scrollbar-moz text-text400 px-0 text-xs">
        {offerContentFiltered.map((content, index) => {
          return (
            <li
              data-id={
                content.includes('Web Coins')
                  ? 'item-content-Web Coin'
                  : content.includes('Rubies')
                    ? 'item-content-Ruby'
                    : ''
              }
              id={
                index === 0
                  ? isWebCoinCard
                    ? 'web-coin-card-content'
                    : ''
                  : ''
              }
              key={`${content.trim()}-${index}`}
              className="flex py-[5px]"
            >
              {content}
            </li>
          );
        })}
        {activeCurrencies?.length &&
        !hasWebCoinPrice &&
        offerType !== 'rewards' &&
        !isFreeTournamentOffer
          ? activeCurrencies.map((currency) =>
              currency.name === 'Web Coin' || currency.name === 'Ruby' ? (
                (isWebCoinCard && currency.name === 'Web Coin') ||
                (currency.name === 'Ruby' && rubiesExistInOfferContent) ||
                Math.round(initialPrice) === 0 ? null : (
                  <li
                    data-id={`item-content-${currency.name}`}
                    id={
                      index === 0
                        ? isWebCoinCard
                          ? 'web-coin-card-content'
                          : `item-content-${currency.name}`
                        : ''
                    }
                    className="flex py-[5px]"
                    key={currency.id}
                  >
                    {formatThousands(currency.rate * Math.round(initialPrice))}{' '}
                    {currency.name}
                  </li>
                )
              ) : offerType === 'tournament' && !initialPrice ? null : (
                <li className="flex py-[5px]" key={currency.id}>
                  {formatThousands(Math.round(currency.rate * initialPrice))}{' '}
                  {currency.name}
                </li>
              )
            )
          : ''}
        {ruby || isWebCoinCard ? null : (
          <li data-id="item-content-VIP" className="flex py-[5px]">
            VIP {t('points')}
          </li>
        )}
      </ul>
    );
  };

  return (
    <div
      className={cn('hover-state h-full w-full', {
        show: show,
      })}
    >
      <div className="hover-state__blur h-full w-full p-[10px]">
        <div
          data-id="item-detail-container"
          className="hover-state__blur__content relative h-full w-full px-5 py-[25px]"
        >
          <ClickableDiv
            onClick={handleCloseIcon}
            className={`absolute right-3 cursor-pointer`}
            id={
              index === 0
                ? isWebCoinCard
                  ? 'web-coin-offer-info-close'
                  : 'cash-pack-info-close'
                : ''
            }
          >
            <IcoMoonIcon iconName="close" className="size-4" />
          </ClickableDiv>
          <div className="flex">
            <div
              className={cn(`pb-5`, {
                selected: !selected && offerDescription,
                section: !(!selected && offerDescription),
              })}
            >
              <p
                onClick={() => setSelected(false)}
                className="m-0 text-sm font-medium"
              >
                {t('offer_contents')}
              </p>
              <div
                className={!selected && offerDescription ? 'underline' : ''}
              />
            </div>

            {offerDescription && (
              <div
                className={cn(`ml-[15px] pb-5`, {
                  selected: selected,
                  section: !selected,
                })}
              >
                <p
                  onClick={() => setSelected(true)}
                  className="m-0 text-sm font-medium"
                >
                  {t('offer_description')}
                </p>
                <div className={selected ? 'underline' : ''} />
              </div>
            )}
          </div>
          {renderSelectedContent()}
        </div>
        {renderButton()}
      </div>
    </div>
  );
}
